import { useEffect, useState } from 'react';
import { getMomentDate } from '../Utils/dates.util';

interface useScrollbarProps {
	from: any;
	to: any;
	interval: any;
}

const useScrollbar = (props: useScrollbarProps) => {
	const { from, to, interval } = props;

	const [maxScroll, setMaxScroll] = useState(0);
	const [scrollOffset, setScrollOffset] = useState<number | null>(null);
	const [range, setRange] = useState<{
		from: number | null;
		to: number | null;
	}>({
		from: null,
		to: null,
	});

	useEffect(() => {
		handleRecalculateRange();
	}, [scrollOffset]);

	const handleRecalculateRange = () => {
		const min = getMomentDate(from);
		min.add(scrollOffset, 'hours');

		let addHours = 0;
		switch (interval) {
			case 'day':
				addHours = 48;
				break;
			case 'year':
				addHours = 1000;
				break;
			default:
				addHours = 168;
				break;
		}

		let max = min.clone().add(addHours, 'hours');
		const maxTo = getMomentDate(to);
		if (max.unix() > maxTo.unix()) {
			min.subtract(addHours, 'hours');
			max = maxTo;
		}

		setRange({
			// @ts-ignore
			from: min,
			// @ts-ignore
			to: max,
		});
	};

	const [scrollTimeout, setScrollTimeout] = useState<number | null>(null);

	const handleScroll = (event: any) => {
		if (scrollTimeout) {
			clearTimeout(scrollTimeout);
		}

		setScrollTimeout(
			setTimeout(() => {
				const { scrollLeft, offsetWidth } = event.target;

				const hours = (scrollLeft + offsetWidth) / 10;

				setScrollOffset(hours);
			}, 500),
		);
	};

	return {
		range,
		setRange,
		maxScroll,
		setMaxScroll,
		setScrollOffset,
		scrollOffset,
		handleRecalculateRange,
		handleScroll,
	};
};

export default useScrollbar;
